import * as z from 'zod';
import { isAddress } from '../address.js';
import { bigIntToNumber } from '../numbers.js';
import { lowercase } from '../string.js';
import { isUUID4, isHex } from '../validation.js';

const stringToDateSchema = z.string().nonempty().pipe(z.coerce.date());
const dateToStringSchema = z.union([
  z.string().nonempty().pipe(z.coerce.date().transform((v) => v.toISOString())),
  z.date().transform((v) => v.toISOString())
]);
const bigIntNumberSchema = z.union([
  z.number(),
  z.bigint().transform(bigIntToNumber)
]);
const addressSchema = z.string().refine(isAddress, {
  message: "Value has to be a valid hex address"
}).transform(lowercase);
const uuidSchema = z.string().refine(isUUID4, {
  message: "Value has to be a valid uuid v4"
});
const arweaveHashSchema = z.string().length(43, {
  message: "Unexpected length for arweave hash, it should always be 43 characters"
});
const strictHexSchema = z.string().refine((value) => isHex(value, { strict: true }), {
  message: "Value has to be a valid hex value"
});

export { addressSchema, arweaveHashSchema, bigIntNumberSchema, dateToStringSchema, strictHexSchema, stringToDateSchema, uuidSchema };
